import * as Sentry from '@sentry/react';

/**
 * Envía un log personalizado a Sentry.
 * Sin opción de usuario: la identidad la pone InitsContainer solo con el guid (DEU-286).
 *
 * @param {('error'|'warning'|'info')} level - Nivel del log.
 * @param {string} message - Mensaje descriptivo del log.
 * @param {object} [options] - Opciones adicionales para contextualizar el log.
 * @param {object} [options.tags] - Tags personalizados (ej: { section: 'checkout', action: 'submit' }).
 * @param {object} [options.extra] - Datos adicionales, sin datos personales (security.md).
 * @param {Error} [options.error] - Error real, para capturar stacktrace (opcional).
 */
export function logToSentry(level, message, options = {}) {
  const { tags, extra, error } = options;
  try {
    Sentry.withScope((scope) => {
      // Añadir tags si se proporcionan
      if (tags) {
        Object.entries(tags).forEach(([key, value]) => {
          scope.setTag(key, value);
        });
      }

      // Añadir datos adicionales si se proporcionan
      if (extra) {
        Object.entries(extra).forEach(([key, value]) => {
          scope.setExtra(key, value);
        });
      }

      // Captura de error o mensaje
      if (error instanceof Error) {
        Sentry.captureException(error);
      } else {
        Sentry.captureMessage(message, level);
      }
    });
  } catch (error) {
    console.error('Error al enviar el log a Sentry:', error);
  }
}

/**
 * Avisa a Sentry de un error del visor. No recibe el usuario: el guid ya lo pone InitsContainer (DEU-286).
 *
 * @param {boolean} isStudent
 * @param {object} location - `location` de React Router.
 * @param {object} [extra] - Lo que manda el visor al fallar.
 */
export function logViewerError(isStudent, location, extra) {
  if (!window.location.host.includes('localhost:')) {
    logToSentry('warning', 'Viewer error', {
      tags: {
        page: 'viewer',
        isStudent: isStudent,
      },
      extra: {
        ...extra,
        currentPath: location.pathname,
        referrer: document.referrer,
        queryParams: location.search,
        previousPath: location.state?.from,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
      },
    });
  }
}
